import { useEffect, useMemo, useState } from "react";
import FloatingMenu from "../../../componente/menuflutuante";
import api from "../../../services/api";
import Aguarde from "../../../componente/aguarde";
import CardTotais from "../../principal/home/components/Darsboard/CardTotais.jsx";
import CardVendedores from "../../principal/home/components/Darsboard/CardVendedores.jsx";
import CardMoeda from "../../principal/home/components/Darsboard/CardMoeda.jsx";
import CardMeta from "../../principal/home/components/Darsboard/CardMeta.jsx";
import "./style.css";

export default function Home() {
  const [tipoUsuario, setTipoUsuario] = useState(
    localStorage.getItem("tempTipo")
  );

  // =====================================================
  // CARDS
  // =====================================================
  const [clientes, setClientes] = useState(0);
  const [qtdecobrarpendente, setQtdeCobrarPendente] = useState(0);
  const [valorcobrarpendente, setValorCobrarPendente] = useState(0);
  const [qtdecobrarefetivado, setQtdeCobrarEfetivado] = useState(0);
  const [valorcobrarefetivado, setValorCobrarEfetivado] = useState(0);
  const [vendas, setVendas] = useState(0);

  // =====================================================
  // VENDEDORES
  // =====================================================
  const [vendedores, setVendedores] = useState([]);

  // =====================================================
  // PAGAMENTOS
  // =====================================================
  const [moeda, setMoeda] = useState([]);

  // =====================================================
  // LOADING
  // =====================================================
  const [loading, setLoading] = useState(false);

  // =====================================================
  // DATAS
  // =====================================================
  const hoje = new Date();

  const formatDate = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

  function dataHoraAtual() {
    const agora = new Date();
    return `${agora.getFullYear()}-${String(
      agora.getMonth() + 1
    ).padStart(2, "0")}-${String(
      agora.getDate()
    ).padStart(2, "0")}T${String(
      agora.getHours()
    ).padStart(2, "0")}:${String(
      agora.getMinutes()
    ).padStart(2, "0")}:${String(
      agora.getSeconds()
    ).padStart(2, "0")}`;
  }

  const [dataInicial, setDataInicial] = useState(
    formatDate(hoje)
  );

  const [dataFinal, setDataFinal] = useState(
    formatDate(hoje)
  );

  // =====================================================
  // COMPARATIVO
  // =====================================================
  const [comparativo, setComparativo] = useState({
    cobradas: 0,
    renovadas: 0,
    caidas: 0,
    vendidas: 0
  });

  // =====================================================
  // DESPESAS
  // =====================================================
  const categorias = [
    "Café da manhã",
    "Almoço",
    "Jantar",
    "Combustível",
    "Hotel",
    "Feira",
    "Extra",
    "Outro"
  ];

  const [categoriaDespesa, setCategoriaDespesa] =
    useState("");
  const [descricaoDespesa, setDescricaoDespesa] =
    useState("");
  const [valorDespesa, setValorDespesa] =
    useState("");
  const [despesas, setDespesas] =
    useState([]);

  // =====================================================
  // DEPÓSITOS
  // =====================================================
  const [bancoDeposito, setBancoDeposito] =
    useState("");
  const [valorDeposito, setValorDeposito] =
    useState("");
  const [depositos, setDepositos] =
    useState([]);

  // =====================================================
  // VALES
  // =====================================================
  const [valorVale, setValorVale] =
    useState("");
  const [vales, setVales] =
    useState([]);

  // =====================================================
  // BANCOS
  // =====================================================
  const [bancos, setBancos] =
    useState([]);

  // =====================================================
  // META
  // =====================================================
  const meta = 100;
  const alcancado = 64;

  // =====================================================
  // FORMATAR MOEDA
  // =====================================================
  const formatarMoeda = (valor) => {
    return Number(valor || 0).toLocaleString(
      "pt-BR",
      {
        style: "currency",
        currency: "BRL"
      }
    );
  };

  // =====================================================
  // TOTAL RECEBIDO
  // =====================================================
  const totalRecebido = useMemo(() => {
    return moeda.reduce(
      (t, item) =>
        t + Number(item.valor || 0),
      0
    );
  }, [moeda]);

  // =====================================================
  // TOTAL DESPESAS
  // =====================================================
  const totalDespesas = useMemo(() => {
    return despesas.reduce(
      (t, item) =>
        t + Number(item.valor || 0),
      0
    );
  }, [despesas]);

  // =====================================================
  // TOTAL DEPÓSITOS
  // =====================================================
  const totalDepositos = useMemo(() => {
    return depositos.reduce(
      (t, item) =>
        t + Number(item.valor || 0),
      0
    );
  }, [depositos]);

  // =====================================================
  // TOTAL VALES
  // =====================================================
  const totalVales = useMemo(() => {
    return vales.reduce(
      (t, item) =>
        t + Number(item.valor || 0),
      0
    );
  }, [vales]);

  // =====================================================
  // TOTAL LÍQUIDO
  // =====================================================
  const totalLiquido = useMemo(() => {
    return (
      totalRecebido -
      totalDespesas -
      totalVales
    );
  }, [
    totalRecebido,
    totalDespesas,
    totalVales
  ]);

  // =====================================================
  // ADICIONAR DESPESA
  // =====================================================
  async function adicionarDespesa() {
    if (!categoriaDespesa) {
      alert("Informe a categoria.");
      return;
    }

    if (
      categoriaDespesa === "Outro" &&
      descricaoDespesa.trim() === ""
    ) {
      alert("Informe a descrição.");
      return;
    }

    if (
      !valorDespesa ||
      Number(valorDespesa) <= 0
    ) {
      alert("Informe o valor.");
      return;
    }

    try {
      setLoading(true);

      await api.post(
        "v1/despesa",
        {
          dtlancamento: dataHoraAtual(),
          descricao:
            categoriaDespesa === "Outro"
              ? descricaoDespesa
              : categoriaDespesa,
          valor: Number(valorDespesa),
          codusuario: Number(
            localStorage.getItem("tempCodUsuario")
          ),
          codempresa: Number(
            localStorage.getItem("tempCodEmpresa")
          ),
          excluido: "N"
        },
        {
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem(
                "tempToken"
              )}`
          }
        }
      );

      setCategoriaDespesa("");
      setDescricaoDespesa("");
      setValorDespesa("");

      await fetchDataMoeda();
    }
    catch (erro) {
      alert(
        erro?.response?.data?.erro ||
        "Erro ao registrar despesa."
      );
    }
    finally {
      setLoading(false);
    }
  }

  // =====================================================
  // REMOVER DESPESA
  // =====================================================
  async function removerDespesa(codDespesa) {
    if (
      !window.confirm(
        "Deseja realmente excluir esta despesa?"
      )
    ) {
      return;
    }

    try {
      setLoading(true);

      await api.delete(
        "v1/despesa/",
        {
          params: {
            coddespesa: codDespesa
          },
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem(
                "tempToken"
              )}`
          }
        }
      );

      await fetchDataMoeda();
    }
    catch (erro) {
      alert(
        erro?.response?.data?.erro ||
        "Erro ao excluir a despesa."
      );
    }
    finally {
      setLoading(false);
    }
  }

  // =====================================================
  // ADICIONAR DEPÓSITO
  // =====================================================
  async function adicionarDeposito() {
    if (!bancoDeposito.trim()) {
      alert("Informe o banco.");
      return;
    }

    if (
      !valorDeposito ||
      Number(valorDeposito) <= 0
    ) {
      alert("Informe o valor.");
      return;
    }

    try {
      setLoading(true);

      await api.post(
        "v1/deposito",
        {
          banco: bancoDeposito.trim(),
          valor: Number(
            valorDeposito
          ),
          dtlancamento:
            dataHoraAtual(),
          codusuario: Number(
            localStorage.getItem(
              "tempCodUsuario"
            )
          ),
          codfuncionario: Number(
            localStorage.getItem(
              "tempCodFuncionario"
            )
          ),
          codempresa: Number(
            localStorage.getItem(
              "tempCodEmpresa"
            )
          ),
          excluido: "N"
        },
        {
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem(
                "tempToken"
              )}`
          }
        }
      );

      setBancoDeposito("");
      setValorDeposito("");
      await fetchDataMoeda();
    }
    catch (erro) {
      alert(
        erro?.response?.data?.erro ||
        "Erro ao registrar depósito."
      );
    }
    finally {
      setLoading(false);
    }
  }

  // =====================================================
  // REMOVER DEPÓSITO
  // =====================================================
  async function removerDeposito(
    codDeposito
  ) {
    if (
      !window.confirm(
        "Deseja realmente excluir este depósito?"
      )
    ) {
      return;
    }

    try {
      setLoading(true);

      await api.delete(
        "v1/deposito/",
        {
          params: {
            coddeposito: codDeposito
          },
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem(
                "tempToken"
              )}`
          }
        }
      );
      await fetchDataMoeda();
    }
    catch (erro) {
      alert(
        erro?.response?.data?.erro ||
        "Erro ao excluir o depósito."
      );
    }
    finally {
      setLoading(false);
    }
  }

  // =====================================================
  // ADICIONAR VALE
  // =====================================================

  // =====================================================
  // ADICIONAR VALE
  // =====================================================
  async function adicionarVale(codFuncionarioSelecionado) {
    if (!codFuncionarioSelecionado) {
      alert("Selecione um funcionário para o vale.");
      return;
    }

    if (!valorVale || Number(valorVale) <= 0) {
      alert("Informe o valor do vale.");
      return;
    }

    try {
      setLoading(true);

      await api.post(
        "v1/vales",
        {
          valor: Number(valorVale),
          dtlancamento: dataHoraAtual(),

          // Funcionário selecionado no campo do CardMoeda
          codfuncionario: Number(codFuncionarioSelecionado),

          codusuario: Number(
            localStorage.getItem("tempCodUsuario")
          ),

          codempresa: Number(
            localStorage.getItem("tempCodEmpresa")
          ),

          excluido: "N"
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`
          }
        }
      );

      setValorVale("");
      await fetchDataMoeda();

    } catch (erro) {
      alert(
        erro?.response?.data?.erro ||
        "Erro ao registrar vale."
      );
    } finally {
      setLoading(false);
    }
  }


  // =====================================================
  // REMOVER VALE
  // =====================================================
  async function removerVale(
    codVale
  ) {
    if (
      !window.confirm(
        "Deseja realmente excluir este vale?"
      )
    ) {
      return;
    }

    try {
      setLoading(true);

      await api.delete(
        "v1/vales/",
        {
          params: {
            codvales: codVale
          },
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem(
                "tempToken"
              )}`
          }
        }
      );

      await fetchDataMoeda();
    }
    catch (erro) {
      alert(
        erro?.response?.data?.erro ||
        "Erro ao excluir o vale."
      );
    }
    finally {
      setLoading(false);
    }
  }

  // =====================================================
  // CARDS
  // =====================================================
  const fetchDataCards = async () => {
    try {
      setLoading(true);

      const response = await api.get(
        "v1/cards",
        {
          params: {
            codequipe:
              localStorage.getItem(
                "tempCodEquipe"
              )
          },
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem(
                "tempToken"
              )}`
          }
        }
      );

      setClientes(
        response.data.clientes
      );
      setQtdeCobrarPendente(
        response.data.qtdecobrancapendente
      );
      setValorCobrarPendente(
        response.data.valorcobrancapendente
      );
      setQtdeCobrarEfetivado(
        response.data.qtdecobrancaefetivado
      );
      setValorCobrarEfetivado(
        response.data.valorcobrancaefetivado
      );
      setVendas(
        response.data.venda
      );
    }
    finally {
      setLoading(false);
    }
  };

  // =====================================================
  // VENDEDORES
  // =====================================================
  const fetchDataVendedores = async () => {
    try {
      setLoading(true);
      const response = await api.get(
        "v1/vendedores",
        {
          params: {
            codequipe:
              localStorage.getItem(
                "tempCodEquipe"
              )
          },
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem(
                "tempToken"
              )}`
          }
        }
      );

      setVendedores(
        response.data
      );
    }
    finally {
      setLoading(false);
    }
  };

  // =====================================================
  // PAGAMENTOS + DESPESAS +
  // DEPÓSITOS + VALES + BANCOS
  // =====================================================
  const fetchDataMoeda = async () => {
    try {
      setLoading(true);

      const response = await api.get(
        "v1/moeda",
        {
          params: {
            codusuario:
              localStorage.getItem(
                "tempCodUsuario"
              ),
            codequipe:
              localStorage.getItem(
                "tempCodEquipe"
              ),
            datainicial:
              dataInicial,
            datafinal:
              dataFinal
          },

          headers: {
            Authorization:
              `Bearer ${localStorage.getItem(
                "tempToken"
              )}`
          }
        }
      );

      if (response.data.pagamentos) {
        setComparativo(
          response.data.comparativo || {
            cobradas: 0,
            renovadas: 0,
            caidas: 0,
            vendidas: 0
          }
        );

        // PAGAMENTOS
        setMoeda(
          response.data.pagamentos
        );

        // DESPESAS
        setDespesas(
          response.data.despesas || []
        );

        // DEPÓSITOS
        setDepositos(
          response.data.depositos || []
        );

        // VALES
        setVales(
          response.data.vales || []
        );

        // BANCOS
        setBancos(
          response.data.bancos || []
        );
      }
    }
    finally {
      setLoading(false);
    }
  };

  // =====================================================
  // USE EFFECT
  // =====================================================
  useEffect(() => {
    fetchDataMoeda();
  }, [
    dataInicial,
    dataFinal
  ]);

  useEffect(() => {
    setTipoUsuario(
      localStorage.getItem(
        "tempTipo"
      )
    );

    fetchDataCards();
    fetchDataVendedores();
    fetchDataMoeda();
  }, []);

  // =====================================================
  // RETURN
  // =====================================================
  return (
    <div className="container-fluid p-3">
      <FloatingMenu />

      <h4 className="mb-4">
        Dashboard - Bem Vindo:{" "}
        {localStorage.getItem(
          "tempUsuario"
        )}
      </h4>

      {loading && <Aguarde />}

      {/* =====================================================
          CHEFE
      ====================================================== */}
      {tipoUsuario === "E" && (
        <>
          <CardTotais
            clientes={clientes}
            qtdecobrarpendente={
              qtdecobrarpendente
            }
            valorcobrarpendente={
              valorcobrarpendente
            }
            qtdecobrarefetivado={
              qtdecobrarefetivado
            }
            valorcobrarefetivado={
              valorcobrarefetivado
            }
            vendas={vendas}
            formatarMoeda={
              formatarMoeda
            }
          />

          <CardMoeda
            dados={{
              dataInicial,
              dataFinal,
              comparativo,
              moeda,
              despesas,
              depositos,
              // NOVOS
              vales,
              bancos,
              categorias,
              categoriaDespesa,
              descricaoDespesa,
              valorDespesa,
              bancoDeposito,
              valorDeposito,
              // NOVO
              valorVale,
              totalRecebido,
              totalDespesas,
              totalDepositos,
              // NOVO
              totalVales,
              totalLiquido
            }}

            actions={{
              setDataInicial,
              setDataFinal,
              setCategoriaDespesa,
              setDescricaoDespesa,
              setValorDespesa,
              setBancoDeposito,
              setValorDeposito,
              // NOVO
              setValorVale,
              adicionarDespesa,
              removerDespesa,
              adicionarDeposito,
              removerDeposito,
              // NOVOS
              adicionarVale,
              removerVale,
              formatarMoeda
            }}
          />

          <CardVendedores
            vendedores={
              vendedores
            }
          />
        </>
      )}

      {/* =====================================================
          COBRADOR
      ====================================================== */}
      {tipoUsuario === "C" && (
        <>
          <CardTotais
            clientes={clientes}
            qtdecobrarpendente={
              qtdecobrarpendente
            }
            valorcobrarpendente={
              valorcobrarpendente
            }
            qtdecobrarefetivado={
              qtdecobrarefetivado
            }
            valorcobrarefetivado={
              valorcobrarefetivado
            }
            vendas={vendas}
            formatarMoeda={
              formatarMoeda
            }
          />

          <CardMoeda
            dados={{
              dataInicial,
              dataFinal,
              comparativo,
              moeda,
              despesas,
              depositos,
              // NOVO
              vales,
              bancos,
              categorias,
              categoriaDespesa,
              descricaoDespesa,
              valorDespesa,
              bancoDeposito,
              valorDeposito,
              // NOVO
              valorVale,
              totalRecebido,
              totalDespesas,
              totalDepositos,
              // NOVO
              totalVales,
              totalLiquido
            }}

            actions={{
              setDataInicial,
              setDataFinal,
              setCategoriaDespesa,
              setDescricaoDespesa,
              setValorDespesa,
              setBancoDeposito,
              setValorDeposito,
              // NOVO
              setValorVale,
              adicionarDespesa,
              removerDespesa,
              adicionarDeposito,
              removerDeposito,
              // NOVOS
              adicionarVale,
              removerVale,
              formatarMoeda
            }}
          />
        </>
      )}

      {/* =====================================================
          VENDEDOR
      ====================================================== */}
      {tipoUsuario === "V" && (
        <>
          <CardMeta
            meta={meta}
            alcancado={alcancado}
          />

          <CardTotais
            clientes={clientes}
            qtdecobrarpendente={
              qtdecobrarpendente
            }
            valorcobrarpendente={
              valorcobrarpendente
            }
            qtdecobrarefetivado={
              qtdecobrarefetivado
            }
            valorcobrarefetivado={
              valorcobrarefetivado
            }
            vendas={vendas}
            formatarMoeda={
              formatarMoeda
            }
          />
        </>
      )}
    </div>
  );
}